var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VAlert',_vm._b({attrs:{"type":"success"}},'VAlert',_vm.$attrs,false),[_vm._v(_vm._s(_vm._f("capitalize")(_vm.message)))])}
var staticRenderFns = []

export { render, staticRenderFns }